var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#13C097",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5656 7.6415L16.4044 5.4276C16.2111 5.21675 15.9388 5.11133 15.6577 5.11133H8.62064C8.04081 5.11133 7.56641 5.58573 7.56641 6.16557V21.7595C7.56641 22.3393 8.04081 22.8137 8.62064 22.8137H19.8922C20.472 22.8137 20.9464 22.3393 20.9464 21.7595V10.4879C20.9464 10.2156 20.841 9.95203 20.6565 9.75876L18.5744 7.6415H18.5656Z",
    fill: "#13C097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 16.8355L18.4219 15.9417C18.4219 15.8312 18.3323 15.7417 18.2219 15.7417L10.8442 15.7417C10.7337 15.7417 10.6442 15.8312 10.6442 15.9417L10.6442 16.8355C10.6442 16.9459 10.7337 17.0355 10.8442 17.0355L18.2219 17.0355C18.3323 17.0355 18.4219 16.9459 18.4219 16.8355Z",
    fill: "#E4FFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4805 13.9825L16.4805 13.0887C16.4805 12.9782 16.3909 12.8887 16.2805 12.8887L10.8442 12.8887C10.7337 12.8887 10.6442 12.9782 10.6442 13.0887L10.6442 13.9825C10.6442 14.0929 10.7337 14.1825 10.8442 14.1825L16.2805 14.1825C16.3909 14.1825 16.4805 14.0929 16.4805 13.9825Z",
    fill: "#E4FFF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4297 19.6885L15.4297 18.7947C15.4297 18.6843 15.3401 18.5947 15.2297 18.5947L10.8441 18.5947C10.7336 18.5947 10.6441 18.6843 10.6441 18.7947L10.6441 19.6885C10.6441 19.799 10.7336 19.8885 10.8441 19.8885L15.2297 19.8885C15.3401 19.8885 15.4297 19.799 15.4297 19.6885Z",
    fill: "#E4FFF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6398 9.75788H17.275C16.7567 9.75788 16.3438 9.33619 16.3438 8.82664V5.35645L20.6398 9.7491V9.75788Z",
    fill: "#A5E9D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlans);
export default __webpack_public_path__ + "static/media/icon_plans.747bd9b1a741dc5571e6969ed7a02f62.svg";
export { ForwardRef as ReactComponent };